import {getChampionships} from '@monpetitgazon/mpg-team-data';
import classNames from 'classnames';
import React from 'react';

export const championshipsRefs = {
  fr: 'fr',
  fr2: 'fr2',
  en: 'gb-eng',
  es: 'es',
  it: 'it',
  cl: 'eu',
  super: 'super',
  can: 'can',
  cdm: 'cdm',
};
export const championshipsById = {
  1: {id: 1, label: 'L1', flag: 'fr', color: 'black'},
  2: {id: 2, label: 'en', flag: 'gb-eng', color: 'black'},
  3: {id: 3, label: 'es', flag: 'es', color: 'black'},
  4: {id: 4, label: 'L2', flag: 'fr', color: 'black'},
  5: {id: 5, label: 'it', flag: 'it', color: 'black'},
  6: {id: 6, label: 'CL', flag: 'eu'},
  7: {id: 7, label: 'Super', flag: 'eu'},
  8: {id: 8, label: 'CDM', flag: 'eu'},
  9: {id: 9, label: 'Euro', flag: 'eu'},
  19: {id: 19, label: 'CAN', flag: 'ma'},
};

const mppChampionshipIds = [1, 4, 6, 8, 9, 19];

export const ChampionshipSelector = ({
  championship,
  onChange,
  onRefresh = () => {},
  fromMpp,
}) => (
  <div>
    {[...getChampionships(), {id: 9, ref: 'cl'}, {id: 8, ref: 'cdm'}]
      .filter(item => (fromMpp ? mppChampionshipIds.includes(item.id) : true))
      .map(value => {
        const championshipData = championshipsById[value.id];

        return (
          <button
            className={classNames('btn btn-box-tool', {
              selected: championshipData === value.id,
            })}
            onClick={() => onChange(value.id)}>
            <div key={value.ref} style={{position: 'relative'}}>
              <span
                key={value.ref}
                style={{
                  width: 24,
                  height: 24,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                className={`flag-icon flag-icon-${championshipData.flag} flag-icon-squared`}>
                <span
                  style={{
                    fontWeight: 'bold',
                    fontSize: 10,
                    color: championshipData.color || 'white',
                  }}>
                  {championshipData.label}
                </span>
              </span>
            </div>
          </button>
        );
      })}
    {!fromMpp && onRefresh && (
      <button className="btn btn-box-tool" onClick={onRefresh}>
        <i className="fa fa-refresh" />
      </button>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/ChampionshipSelector/index.js